<template>
  <div class="tit3 w100 mt40"><a href="">联系我们</a></div>
  <ul class="gsjj01">
    <li class="zcb1">服务热线<br>
      {{data.tel}}
    </li>
    <li class="zcb2">在线QQ<br>
      {{data.qq}}
    </li>
    <li class="zcb3">24小时热线<br>
      {{data.phone_number}}
    </li>
    <li class="zcb4">投诉邮箱<br>
      {{data.email}}
    </li>
  </ul>
</template>

<script>
import {getBaseConfig} from "@/api/home"
import {initObject} from "@/utils"
export default {
  data() {
    return {
      data:{
        tel: '',
        phone_number: '',
        qq: '',
        email: '',
      }
    }
  },
  created() {
    this.getData()
  },
  methods:{
    getData(){
      getBaseConfig().then((response)=>{
        this.data = initObject(this.data,response)
      })
    }
  }
}
</script>